import { Button, Grid, MenuItem, Typography } from '@material-ui/core'
import { GridColDef, GridColumnMenuContainer } from '@mui/x-data-grid'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { ConditionalTooltip } from 'src/components/ConditionalTooltip'
import {
  LeituraPlanilhaFretePedagioDialog,
  LimparInformacoes
} from '../components'
import { IMPORTAR_DADOS_TABELA_FRETE_DISABLED } from '../components/LeituraPlanilhaFretePedagioDialog/Messages'
import contratoStore from '../store/store'
import AdicionarColunaDialog from './AdicionarColunaDialog'
import EditarColunaDialog from './EditarColunaDialog'
import TabelaContratoDataGrid from './TabelaContratoDataGrid'

interface ColumnProps {
  hideMenu: () => void
  currentColumn: GridColDef
  open: boolean
}

interface ActionColumnMenuItemProps {
  columnName: string
  handleOnClick?: (e: any) => void
}

const TabelaContratoColumnMenu = ({
  hideMenu,
  currentColumn,
  open
}: ColumnProps) => {
  return (
    <GridColumnMenuContainer
      hideMenu={hideMenu}
      currentColumn={currentColumn}
      open={open}
    >
      <DeleteMenuItem
        handleOnClick={hideMenu}
        columnName={currentColumn.field}
      />
      <UpdateMenuItem columnName={currentColumn.field} />
    </GridColumnMenuContainer>
  )
}

const DeleteMenuItem = ({
  columnName,
  handleOnClick
}: ActionColumnMenuItemProps) => (
  <MenuItem
    onClick={e => {
      contratoStore.removeCapacidade(columnName)
      handleOnClick?.(e)
    }}
  >
    Remover
  </MenuItem>
)

const UpdateMenuItem = ({ columnName }: ActionColumnMenuItemProps) => (
  <MenuItem
    onClick={() => {
      contratoStore.capacidadeEmEdicao = columnName
      contratoStore.openEditarColunaDialog()
    }}
  >
    Editar
  </MenuItem>
)

const TabelaFreteForm = () => {
  const [openModalPlanilha, setOpenModalPlanilha] = useState(false)
  const [openModalClear, setOpenModalClear] = useState(false)

  const diabledImportarPlanilha =
    !!contratoStore.tabelaFrete.rows.length ||
    contratoStore.tabelaFrete.columns.length > 3

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} lg={4}>
        <Button
          fullWidth
          type="button"
          variant="outlined"
          onClick={() => contratoStore.addFaixaKmTabelaFrete()}
        >
          Adicionar Faixa de KM
        </Button>
      </Grid>
      <Grid item xs={12} md={12} lg={4}>
        <Button
          fullWidth
          type="button"
          variant="outlined"
          onClick={() => contratoStore.openAdicionarColunaDialog()}
        >
          Adicionar Capacidade
        </Button>
      </Grid>
      <Grid item xs>
        <Button
          fullWidth
          type="button"
          variant="outlined"
          onClick={() => setOpenModalClear(true)}
        >
          Limpar Informações
        </Button>
      </Grid>
      <Grid item xs>
        <ConditionalTooltip
          enabled={diabledImportarPlanilha}
          title={
            <Typography variant="subtitle1">
              {IMPORTAR_DADOS_TABELA_FRETE_DISABLED}
            </Typography>
          }
        >
          <Button
            fullWidth
            type="button"
            variant="contained"
            color="primary"
            onClick={() => setOpenModalPlanilha(true)}
            disabled={diabledImportarPlanilha}
          >
            Importar Planilha
          </Button>
        </ConditionalTooltip>
      </Grid>
      <Grid item xs={12}>
        <TabelaContratoDataGrid
          rows={contratoStore.tabelaFrete.rows}
          columns={contratoStore.tabelaFrete.columns}
          setCellValue={contratoStore.setValorTabelaFrete}
          columnMenuComponent={TabelaContratoColumnMenu}
        />
      </Grid>
      <AdicionarColunaDialog />
      <EditarColunaDialog />
      <LeituraPlanilhaFretePedagioDialog
        open={openModalPlanilha}
        handleClose={() => setOpenModalPlanilha(false)}
      />
      <LimparInformacoes
        handleClose={() => setOpenModalClear(false)}
        primaryAction={() => {
          contratoStore.clearTabelas()
          contratoStore.setInitialValuesTabelaFrete()
          contratoStore.setInitialValuesTabelaPedagio()

          setOpenModalClear(false)
        }}
        open={openModalClear}
      />
    </Grid>
  )
}

export default observer(TabelaFreteForm)
